import { GOOGLE_MAPS_BASE_URL } from '@/config';

export const generateGoogleMapsUrl = address => {
  const { street = '', number = '', complement = '', neighborhood = '', city = '', state = '', zipcode = '' } = address;

  const fullAddress = [street, number, complement, neighborhood, city, state, zipcode].filter(Boolean).join(', ');

  return `${GOOGLE_MAPS_BASE_URL}/?api=1&query=${encodeURIComponent(fullAddress)}`;
};
